define('Winering.Model', [
    'Backbone',
    'Utils'
], function WineringModel(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Winering.Service.ss'))
    });
});
